import Vue from "vue";
const sectionsBooksPages = new Map();
export default {
  namespaced: true,
  state: {
    enable: true,
    showMefoArea: false,
    kickout: false,
    no_space: false,
    connected: false,
    loading: false,
    currentShasSectionId: -1,
    currentShasId: -1,
    showMefPurchaseMsg: true,
    userFavs: [],
    showSearchBar: false,
    openingMefoBook: false,
  },
  mutations: {
    TOGGLE_SEARCH_BAR(state) {
      state.showSearchBar = !state.showSearchBar;
    },
    SET_SECTION_BOOKS_PAGES(state, payload) {
      sectionsBooksPages.set(payload.sectionId, payload.data);
    },
    SET_SHOW_MEF_PURCHASE_MESSAGE(state, show) {
      state.showMefPurchaseMsg = show;
    },
    SET_SHOW_MEFO_AREA(state, show) {
      state.showMefoArea = show;
    },
    SET_MEFO_ENABLE(state, v) {
      state.enable = v;
    },
    SET_KICKOUT(state, v) {
      state.kickout = v;
      if (v) state.connected = false;
    },
    SET_CONNECTED(state, v) {
      state.connected = v;
    },
    SET_NO_SPACE(state, v) {
      state.no_space = v;
      if (v) state.connected = false;
    },
    SET_LOADING(state, v) {
      state.loading = v;
    },
    SET_CURRENT_SHAS_SECTION_ID(state, id) {
      state.currentShasSectionId = id;
    },
    SET_CURRENT_SHAS_ID(state, bookId) {
      state.currentShasId = bookId;
    },
    SET_USER_FAV_BOOK(state, payload) {
      const { mas, book, subbook } = payload;
      if (state.userFavs.hasOwnProperty(mas)) {
        Vue.set(state.userFavs, mas, [
          ...state.userFavs[mas],
          { book: book, subbook: subbook },
        ]);
      } else {
        Vue.set(state.userFavs, mas, [{ book: book, subbook: subbook }]);
      }
    },
    DELETE_USER_FAV_BOOK(state, payload) {
      const { mas, book, subbook } = payload;
      if (state.userFavs.hasOwnProperty(mas)) {
        Vue.set(
          state.userFavs,
          mas,
          state.userFavs[mas].filter(
            (item) => !(item.book === book && item.subbook === subbook)
          )
        );
      }
    },
  },
  actions: {
    toggleSearchBar({ commit }) {
      commit("TOGGLE_SEARCH_BAR");
    },
    setSectionBookPages({ commit }, payload) {
      commit("SET_SECTION_BOOKS_PAGES", payload);
    },
    setShowMefPurchaseMsg({ commit }, show) {
      commit("SET_SHOW_MEF_PURCHASE_MESSAGE", show);
    },
    setUserFavBook({ commit }, idObj) {
      commit("SET_USER_FAV_BOOK", idObj);
    },
    deleteUserFavBook({ commit }, idObj) {
      commit("DELETE_USER_FAV_BOOK", idObj);
    },
    setLoading({ commit }, v) {
      commit("SET_LOADING", v);
    },
    setShowMefoArea({ commit }, show) {
      commit("SET_SHOW_MEFO_AREA", show);
    },
    setKickOut({ commit }, v) {
      commit("SET_KICKOUT", v);
    },
    setNoSpace({ commit }, v) {
      commit("SET_NO_SPACE", v);
    },
    setMefoEnable({ commit }, v) {
      commit("SET_MEFO_ENABLE", v);
    },
    setConnected({ commit }, v) {
      commit("SET_CONNECTED", v);
    },
    setCurrentShasSectionId({ commit }, id) {
      commit("SET_CONNECTED", id);
    },
    setCurrentShasId({ commit }, bookId) {
      commit("SET_CURRENT_SHAS_ID", bookId);
    },
  },
  getters: {
    getSectionBookPages(state) {
      return sectionsBooksPages;
    },
    showMefPurchaseMsg(state) {
      return state.showMefPurchaseMsg;
    },
    getShowSearchBar(state) {
      return state.showSearchBar;
    },
  },
};
